import { LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration for Microsoft Entra ID authentication.
 * All values are read from environment variables at build time.
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_TENANT_ID || 'common'}`,
    redirectUri: process.env.REACT_APP_ENTRA_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
    },
  },
};

/**
 * Scopes requested during login.
 * openid and profile are included by default.
 * We do NOT request an api:// scope here — the ID token itself is used
 * to authenticate against the backend API.
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
